import {useState} from "react";

import {FilterFood} from "../../../utils/filters";
import Filters from "../../Filters";
import {useStateValue} from "../../../context/StateProvider";
import Loader from "../../Loader";
import MenuContainer from "../../MenuContainer";

const Menu = ({title}: { title?: string }) => {
    const [scrollValue] = useState(0);
    const [{foodItems}] = useStateValue();
    const [{categories}] = useStateValue();
    const [filter, setFilter] = useState<string>("all");

    return (
        <section className="w-full my-5" id="menu">
            {(!categories ? (
                <Loader progress={"Загрузка меню"}/>
            ) : (
                <Filters filter={filter} setFilter={setFilter}/>
            ))}
            <MenuContainer
                className="bg-containerbg"
                col
                scrollOffset={scrollValue}
                items={filter === "all" ? foodItems : FilterFood(filter)}
            />
        </section>
    );
};

export default Menu;
